import { Component, OnInit } from '@angular/core';
import { LanguagesService } from "src/app/services/languagesService/languages.service";
import { Router, RouterEvent } from '@angular/router';

@Component({
  selector: 'app-geochallenges-tabs',
  templateUrl: './geochallenges-tabs.page.html',
  styleUrls: ['./geochallenges-tabs.page.scss'],
})
export class GeochallengesTabsPage implements OnInit {
  selectedPath = '';
  constructor(public languageService: LanguagesService, private router:Router) { 
    this.router.events.subscribe((event: RouterEvent) => {
      if(event && event.url){
        this.selectedPath = event.url;
      }
    });
  }

  ngOnInit() {
  }

  get getTextsIUGeochallengesList() {
    return this.languageService.textsIU.page_geochallenges_list;
  }

}
